import { Stack, Typography } from '@mui/material';

import alertSource from '@assets/images/alert.svg';

export function ErrorOrNotFoundContent() {
  return (
    <Stack gap={3} alignItems="center" padding={4}>
      <img src={alertSource} alt="Falha ao carregar informações" height={90} />
      <Typography variant="h5" textAlign="center">
        Atenção! Não conseguimos carregar os relatórios.
      </Typography>
    </Stack>
  );
}
